import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from "react";
import uniqueId from "lodash.uniqueid";
import { ErrorMessage } from "formik";
import { Form } from "react-bootstrap"; // Global Form Methods

import FormMethods from "./Methods";

var FormCheckboxHtmlLabel = /*#__PURE__*/function (_Component) {
  _inherits(FormCheckboxHtmlLabel, _Component);

  var _super = _createSuper(FormCheckboxHtmlLabel);

  function FormCheckboxHtmlLabel(props) {
    var _this;

    _classCallCheck(this, FormCheckboxHtmlLabel);

    _this = _super.call(this, props);
    _this.handleFocus = FormMethods.handleFocus.bind(_assertThisInitialized(_this));
    _this.handleBlur = FormMethods.handleBlur.bind(_assertThisInitialized(_this));
    _this.state = {
      active: typeof props.value !== "undefined" && props.value !== "" ? true : false,
      checked: props.checked
    };
    _this.id = uniqueId(); // this.onClick = props?.onClick || const sample = () => ""

    return _this;
  }

  _createClass(FormCheckboxHtmlLabel, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(newProps) {
      if (newProps.checked !== this.props.checked) {
        this.setState({
          checked: newProps.checked
        });
      }
    }
  }, {
    key: "onChange",
    value: function onChange(e) {
      if (e.target.checked !== this.props.checked) {
        this.setState({
          checked: e.target.checked
        });
      }

      if (typeof this.props.changeHandler !== "undefined") {
        return this.props.changeHandler(e.currentTarget.value);
      }

      if (typeof this.props.changeFullHandler !== "undefined") {
        return this.props.changeFullHandler(e);
      }
    }
  }, {
    key: "onClick",
    value: function onClick(e) {
      if (e.target.checked !== this.props.checked) {
        this.setState({
          checked: e.target.checked
        });
      }

      if (typeof this.props.onClick === "function") {
        this.props.onClick(e);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          _this$props$field = _this$props.field,
          name = _this$props$field.name,
          field = _objectWithoutProperties(_this$props$field, ["name"]),
          id = _this$props.id,
          props = _objectWithoutProperties(_this$props, ["field", "id"]);

      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Form.Group, {
        controlId: name
      }, /*#__PURE__*/React.createElement(Form.Label, {
        className: "\n              cb-form__checkbox\n              form-control\n              ".concat(typeof this.props.field.value !== "undefined" && this.props.field.value[0] === "on" ? "is-active" : "", "\n            ") // htmlFor={this.props.field.name}

      }, /*#__PURE__*/React.createElement(Form.Check, {
        value: this.props.value,
        id: id || "".concat(this.props.field.name, "-").concat(this.id),
        name: this.props.field.name,
        type: this.props.type,
        placeholder: this.props.placeholder,
        checked: this.state.checked,
        onClick: function onClick(e) {
          return _this2.onClick(e);
        },
        onChange: function onChange(e) {
          return _this2.onChange(e);
        },
        onBlur: field.onBlur,
        onFocus: this.handleFocus,
        onError: field.handleError
      }), /*#__PURE__*/React.createElement("div", {
        className: "cb-form__checkbox-label",
        dangerouslySetInnerHTML: {
          __html: this.props.label
        }
      })), /*#__PURE__*/React.createElement(ErrorMessage, {
        name: name
      }, function (msg) {
        return /*#__PURE__*/React.createElement("div", {
          className: "cb-form__error-message"
        }, msg);
      })));
    }
  }]);

  return FormCheckboxHtmlLabel;
}(Component);

FormCheckboxHtmlLabel.defaultProps = {
  type: "text",
  value: "",
  className: "",
  placeholder: ""
};
export default FormCheckboxHtmlLabel;